import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNO = function FlagNO() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M.86 31.521a25.021 25.021 0 0 0 8.922 13.313V31.521H.86ZM22.825 49.904A25.33 25.33 0 0 0 25 50c11.551 0 21.27-7.834 24.14-18.478H22.824v18.383ZM49.138 18.478C46.27 7.834 36.55 0 25 0c-.732 0-1.457.033-2.174.095v18.383h26.313ZM9.782 5.167A25.021 25.021 0 0 0 .86 18.479h8.922V5.167Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M49.788 21.74H19.565V.593a24.83 24.83 0 0 0-6.522 2.446v18.7H.213a25.213 25.213 0 0 0 0 6.52h12.831v18.7a24.831 24.831 0 0 0 6.522 2.446V28.26h30.223a25.26 25.26 0 0 0 0-6.522Z"
  }));
};
FlagNO.displayName = 'FlagNO';
export default withFlagWrapper(FlagNO);
//# sourceMappingURL=index.js.map